<div class="image-dialog-container">
    <img [src]="data.imageUrl" alt="Imagen ampliada" />
</div>
